import React from 'react'

import { ContentWithOffset } from '../../components/scharedStyles/style'
import DatabaseContent from './DatabaseContent'
import DatabaseModals from './DatabaseModals'
import DatabaseSidebar from './DatabaseSidebar'
import { useDatabaseEffects } from './hooks'
import { PageLayout } from './style'

const Database = () => {
    useDatabaseEffects()

    return (
        <>
            <DatabaseModals />

            <ContentWithOffset>
                <PageLayout>
                    <DatabaseSidebar />
                    <DatabaseContent />
                </PageLayout>
            </ContentWithOffset>
        </>
    )
}

export default Database
